import { request } from './client';
import type { AnswerRequest, AnswerResponse, ReviewQueue, ReviewSummary } from './types';

export interface QueueOptions {
  timeZone: string;
  deckId?: string;
  signal?: AbortSignal;
}

/** Returns the cards to study now, in the order to show them. */
export function getReviewQueue(options: QueueOptions): Promise<ReviewQueue> {
  const params = new URLSearchParams({ time_zone: options.timeZone });
  if (options.deckId !== undefined) {
    params.set('deck_id', options.deckId);
  }

  return request<ReviewQueue>(
    `/review/queue?${params.toString()}`,
    options.signal ? { signal: options.signal } : {},
  );
}

/** Records an answer. Safe to retry with the same client_review_id. */
export function submitAnswer(body: AnswerRequest): Promise<AnswerResponse> {
  return request<AnswerResponse>('/review/answers', { method: 'POST', body });
}

/** Counts what each deck has to study today, for choosing what to study. */
export function getReviewSummary(options: {
  timeZone: string;
  signal?: AbortSignal;
}): Promise<ReviewSummary> {
  const params = new URLSearchParams({ time_zone: options.timeZone });

  return request<ReviewSummary>(
    `/review/summary?${params.toString()}`,
    options.signal ? { signal: options.signal } : {},
  );
}
